// MovieDetail helper functions and data
import { MovieTabsOption } from "./MovieDetail.types";
import { ScrollableOption } from "components/global/ScrollableTabs/ScrollableTabs.types";
import variables from "styles/util/variables";
import { BasicInternationalization } from "types/common.types";

const { palette } = variables;

export const getMovieStatusList = (t: BasicInternationalization) => [
  {
    text: t.movie.available,
    backgroundColor: palette.white
  },
  {
    text: t.movie.unavailable,
    backgroundColor: palette["gray-s0-l40"]
  },
  {
    text: t.movie.depleted,
    backgroundColor: palette["red-s95-l65"]
  }
];

export const getTabs = (
  t: BasicInternationalization
): ScrollableOption<MovieTabsOption>[] => {
  return [
    { title: t.movie.screenings, name: "screenings" },
    { title: t.movie.trailers, name: "trailers" },
    { title: t.movie.information, name: "information" }
  ];
};
